import { RootState } from 'editor/src/store/index';

import getSelectedMediaElementsObjects from './getSelectedMediaElementsObjects';

const isAnyImageSelected = (state: RootState) =>
  !!getSelectedMediaElementsObjects(state).some((element) => element?.type === 'image');

export default isAnyImageSelected;
